import React from 'react';
import MarkdownPage from '../components/MarkdownPage';

export default function TermsPage() {
  return <MarkdownPage src="/terms.md" />;
}